<template>
  <div>
    <div class="mx-auto w-full">
      <div class="bg-yellow-500 px-6 py-2 shadow flex justify-center">
        <div class="flex items-baseline">
          <img
            class="mx-auto w-12 flex-none"
            src="~assets/images/logo/dlto.svg"
            alt="deelotto"
          />
          <!-- <span
            class="text-xl font-lg text-center font-semibold text-black flex-none"
          >
            deelotto
          </span> -->
        </div>
      </div>
    </div>
  </div>
</template>
